import axios from 'axios';
import i18n from '@/i18n';

export default {
  baseURL: process.env.BASE_URL + 'api/reportfile',

  getReportFiles(filter, options, cancelToken) {
    return axios.post('', {
        'PageSize': options ? options.pageSize : null,
        'Page': options ? options.page : null,
        'ClientIds': (filter && _.size(filter.clientIds) > 0) ? filter.clientIds.join() : null,
        'PropertyIds': (filter && _.size(filter.propertyIds) > 0) ? filter.propertyIds.join('|') : null,
        'ColumnFilter': (filter && _.size(filter.columnFilter) > 0) ? JSON.stringify(filter.columnFilter) : null,
        'SortBy': (filter && filter.sortBy) ? filter.sortBy : null,
        'SortDescending': (filter && filter.sortDescending) ? filter.sortDescending : null,
        'LocalizationId': (options && options.localizationId) ? options.localizationId : i18n.locale
      },
      { 
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  },

  getReportFileCategories(clientId, cancelToken) {
    return axios.get(`${clientId}/categories`,
      { 
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  },

  updateReportFiles(reportFiles) {
    return axios
      .put('', reportFiles,
        {
          baseURL: this.baseURL,
          headers: { 'Content-Type': 'application/json' }
        });
  },

  deleteReportFiles(reportFileIds) {
    return axios.delete('',
      {
        baseURL: this.baseURL,
        data: {
          'ReportFileIds': reportFileIds
        }
      })
      .then(function (response) {
        return response;
      });
  },

  downloadReportFile(reportFileId, cancelToken) {
    return axios.get('download-file',
      {
        baseURL: this.baseURL,
        params: {
          'report-file-id': reportFileId,
          'localization-id': i18n.locale
        },
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  },

  downloadReportFiles(reportFileIds, downloadProgressCallback, cancelToken) {
    return axios.post('download-files', {
        'ReportFileIds': reportFileIds,
        'LocalizationId': i18n.locale
      },
      { 
        baseURL: this.baseURL,
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null,
        onDownloadProgress: downloadProgressCallback
      })
      .then(function (response) {
        return response;
      });
  },
};